import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';

export const createCountryLabelVectorLayer = (): VectorLayer => {
  return new VectorLayer({
    source: new VectorSource({ features: [] }),
    declutter: true,
    style: undefined,
  });
};
